module.exports = __webpack_public_path__ + "img/dots_mtp2.928f8409.png";